import React, { useState } from 'react';
import cambioEstadoService from "../../services/cambioEstadoService";
import { obtenerSiguienteEstadoART } from "../../services/art/artEstadoService";
import { toast } from "react-toastify";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import DescriptionIcon from '@mui/icons-material/Description';
import EventNoteIcon from '@mui/icons-material/EventNote';
import SendIcon from '@mui/icons-material/Send';

function GestorCitacionART({ tramite, onAvanzar }) {
    const [cargando, setCargando] = useState(false);
    const [aclaracionesCitacion, setAclaracionesCitacion] = useState("");

    const handleConfirmarCitacion = async () => {
        setCargando(true);
        try {
            const siguienteEstado = await obtenerSiguienteEstadoART(tramite.nombreEstadoActual, "Respuesta ART");

            if (!siguienteEstado) {
                toast.error("No se pudo obtener el estado destino: Respuesta ART.");
                setCargando(false);
                return;
            }

            const comentarioFinal = aclaracionesCitacion.trim()
                ? `Aclaraciones de la citación:\n${aclaracionesCitacion}`
                : `Citación ART registrada sin aclaraciones adicionales.`;

            await cambioEstadoService.cambiarEstado(tramite.idTramite, {
                idEstado: siguienteEstado.id || siguienteEstado.idEstado,
                comentario: comentarioFinal
            });

            toast.success("Citación registrada. Avanzando a Respuesta ART.");
            onAvanzar();
        } catch (error) {
            console.error("Error al registrar citación:", error);
            toast.error("Error: " + (error.response?.data?.message || error.message));
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
            {/* Header con Ícono y Título */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fw-bold text-info mb-0">Citación ART</h4>
                <span className="badge bg-info rounded-pill px-3 py-2">
                    <EventNoteIcon fontSize="small" className="me-1" />
                    Registro de Citación
                </span>
            </div>

            {/* Alert informativo */}
            <div className="alert alert-info border-0 rounded-3">
                <strong>Información:</strong>
                <p className="mb-0 mt-1">
                    Registre los detalles de la citación del cliente por parte de la aseguradora.
                    Indique si llegó la notificación, si fue dentro/fuera de término, si asistió el cliente y si se realizaron estudios.
                </p>
            </div>

            {/* --- SECCIÓN DE ACLARACIONES --- */}
            <div className="mt-4">
                <h6 className="fw-semibold text-primary mb-3">
                    <DescriptionIcon fontSize="small" className="me-2 mb-1" />
                    Aclaraciones de la Citación
                </h6>
                <textarea
                    className="form-control"
                    rows="6"
                    placeholder="Ej: ¿Llegó la notificación al estudio o al cliente? ¿Fue fuera de término? ¿Asistió el cliente? ¿Le realizaron estudios adicionales?"
                    value={aclaracionesCitacion}
                    onChange={(e) => setAclaracionesCitacion(e.target.value)}
                    disabled={cargando}
                    style={{ borderRadius: '0.5rem',
                        border: '1px solid #e0e0e0',
                        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", 
                        lineHeight: '1.5' }}
                />
                <small className="text-muted mt-2 d-block">
                    Estos comentarios se guardarán en el historial del trámite bajo el estado "Citación ART".
                </small>
            </div>

            {/* --- ACCIONES DE SALIDA --- */}
            <div className="d-flex justify-content-center flex-wrap gap-3 mt-4 pt-3 border-top">
                <button
                    className="btn btn-success d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                    onClick={handleConfirmarCitacion}
                    disabled={cargando}
                >
                    {cargando ? (
                        <>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Procesando...
                        </>
                    ) : (
                        <>
                            <SendIcon fontSize="small" />
                            Ir a Respuesta ART
                        </>
                    )}
                </button>
            </div>
        </div>
    );
}

export default GestorCitacionART;

